module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Bd.6ae72e8.ttf";